import { datadogRum } from '@datadog/browser-rum';
import userConstants from '../ActionType';

const setUser = (user) => {
  const result = Object.assign({}, user?.[0]);
  result.self = {};
  result.links = {};
  // eslint-disable-next-line dot-notation
  result.email = user?.[0]?.['_emails']?.[0]?.['_element']?.[0]?.email;
  return result;
};

const initialState = {
  loggedIn: false, error401: false, errorSyncRequired: false,user: {}, apiToken: {}, myCompanyPermission: {}, localeLanguage: {}, returnsAllowableFileSize: '', ctoAllowableCustomers: '', reOrderExcludeItems: '', myAccountPermission: '', returnsAllowableFiles: '', returnsAllowableFileTypes: '', dealerLocatorPermission: {}, orderReviewAccountNumber: {}, slipLabLocatorPermission: {}, orderTypes: {}, userList: {}, apiError: false, myCompanyAdminRoleCount: '', globalDateFormat: '', itemLimitCount: '', isShipToEnable : false, backOrderedFlag: false, freightDetails: '', isCoveoSearchEnabled: null, marketingBannerData: null, footerTopMargin :false, hasMultipleAccounts: false,
};

const authentication = (state = initialState, action) => {
  switch (action?.type) {
    case userConstants.LOGIN_REQUEST:
      return {
        loggingIn: true,
      };
    case userConstants.LOGIN_SUCCESS:
      datadogRum.setUser({
        // to-do: use uidpk instead of hardcoded value
        id: '123',
        account: action?.user?.[0]?.CP_ACCOUNT_ID,
        // eslint-disable-next-line no-underscore-dangle
        email: action?.user?.[0]?.CP_USER_NAME,
      });
      return {
        ...state,
        loggedIn: true,
        user: setUser(action?.user),
        error401: false,
        errorSyncRequired: false,
        links: action?.user[0]?.links,
      };
    case userConstants.LOGOUT:
      return {
        ...initialState,
      };
    case userConstants.LOGIN_FAILURE:
      return {
        ...state,
        user: undefined,
        loggedIn: undefined,
      };
    case userConstants.LOGIN_FAILURE_401:
      return {
        ...state,
        error401: true,
      };
    case userConstants.LOGIN_FAILURE_SYNC_REQUIRED:
      return {
        ...state,
        errorSyncRequired: true,
      };
    case userConstants.API_FAILS:
      return {
        ...state,
        apiError: action?.payload,
      };
    case userConstants.API_TOKEN:
      return {
        ...state,
        apiToken: action?.apiToken,
      };

    case userConstants.ACCEPT_MG_TEARMS:
      return {
        ...state,
        user: setUser(action?.user),
      };
    case userConstants.MY_COMPANY_PERMISSION:
      return {
        ...state,
        myCompanyPermission: action?.accessPermission,
      };
    case userConstants.AWSS3_MAX_ALLOWABLE_FILE_SIZE:
      return {
        ...state,
        returnsAllowableFileSize: action?.accessPermission,
      };
    case userConstants.AWSS3_MAX_ALLOWABLE_FILES:
      return {
        ...state,
        returnsAllowableFiles: action?.accessPermission,
      };
    case userConstants.AWSS3_MAX_ALLOWABLE_FILE_TYPES:
      return {
        ...state,
        returnsAllowableFileTypes: action?.accessPermission,
      };
    case userConstants.CTO_ALLOWABLE_CUSTOMERS:
      return {
        ...state,
        ctoAllowableCustomers: action?.accessPermission,
      };
    case userConstants.REORDER_EXCLUDE_ITEMS:
      return {
        ...state,
        reOrderExcludeItems: action?.accessPermission,
      };
    case userConstants.MY_ACCOUNT_PERMISSION:
      return {
        ...state,
        myAccountPermission: action?.accessPermission,
      };
    case userConstants.LOCALE_LANG_SET:
      return {
        ...state,
        localeLanguage: action?.accessPermission,
      };
    case userConstants.DEALER_LOCATOR_PERMISSION:
      return {
        ...state,
        dealerLocatorPermission: action?.accessPermission,
      };
    case userConstants.ORDER_REVIEW_ACCOUNT_NUMBER:
      return {
        ...state,
        orderReviewAccountNumber: action?.accessPermission,
      };
    case userConstants.MY_COMPANY_ADMIN_ROLE_COUNT:
      return {
        ...state,
        myCompanyAdminRoleCount: action?.accessPermission,
      };
    case userConstants.ITEM_LIMIT_COUNT:
      return {
        ...state,
        itemLimitCount: action?.accessPermission,
      };
    case userConstants.BACK_ORDERED_FLAG:
      return {
        ...state,
        backOrderedFlag: action?.accessPermission,
      };
    case userConstants.GLOBAL_DATE_FORMAT:
      return {
        ...state,
        globalDateFormat: action?.accessPermission?.replace('DD', 'dd')?.replace('YYYY', 'yyyy'),
      };
    case userConstants.GLOBAL_PHONE_FORMAT:
      return {
        ...state,
        globalPhoneFormat: action?.accessPermission,
      };
    case userConstants.SET_HAS_MULTIPLE_ACCOUNTS:
      return {
        ...state,
        hasMultipleAccounts: action?.hasMultipleAccounts,
      };
    case userConstants.FREIGHT_DETAILS:
      let parsedFreightDetails = [];

  try {
    let raw = action?.accessPermission;

    if (typeof raw === 'string') {
      // Remove outer quotes
      raw = raw.trim();
      if (raw.startsWith('"') && raw.endsWith('"')) {
        raw = raw.slice(1, -1);
      }

      // Now raw is a valid JSON array string
      parsedFreightDetails = JSON.parse(raw);
    }
  } catch (e) {
    console.error('Invalid freightDetails JSON:', action?.accessPermission);
  }

  return {
    ...state,
    freightDetails: parsedFreightDetails,
  };
    case userConstants.IS_COVEO_SEARCH_ENABLED:
      return {
        ...state,
        isCoveoSearchEnabled: action?.accessPermission === true || String(action?.accessPermission).toLowerCase() === 'true',
      };
    case userConstants.SLEEPlAB_LOCATOR_PERMISSION:
      return {
        ...state,
        slipLabLocatorPermission: action?.accessPermission,
      };
    case userConstants.GET_REQUEST_TYPE:
      return {
        ...state,
        orderTypes: action?.orderTypes,
      };
    case userConstants.GET_ALL_USER_LIST:
      return {
        ...state,
        userList: action?.userList,
      };
    case userConstants.SET_USER_FLAG:
      return {
        ...state,
        [action.key]: action?.value,
      };
    case userConstants.SET_MARKETING_BANNER_DATA:
      return {
        ...state,
        marketingBannerData: action?.payload,
      };
    case userConstants.SET_FOOTER_TOP_MARGIN:
      return {
        ...state,
        footerTopMargin: action?.payload,
      };

    default:
      return state;
  }
};
export default authentication;

